<script lang="ts">
  import type { ScriptChoice } from '../lib/types';

  interface Props {
    choices: ScriptChoice[];
    disabled?: boolean;
    onselect: (choice: ScriptChoice) => void;
  }

  let { choices, disabled = false, onselect }: Props = $props();
</script>

<div class="hd-script-choices" role="group">
  {#each choices as choice, i (i)}
    <button
      type="button"
      class="hd-script-choices__btn"
      {disabled}
      onclick={() => onselect(choice)}
    >
      {choice.label}
    </button>
  {/each}
</div>

<style>
  .hd-script-choices {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px 16px 16px;
    border-top: 1px solid var(--hd-border, #e2e8f0);
    background: var(--hd-surface, #ffffff);
  }
  .hd-script-choices__btn {
    flex: 1 1 auto;
    min-width: 140px;
    border: 1px solid var(--hd-border, #e2e8f0);
    background: var(--hd-surface, #ffffff);
    color: var(--hd-fg, #0f172a);
    border-radius: 10px;
    padding: 10px 14px;
    font: inherit;
    font-size: 13px;
    font-weight: 500;
    text-align: left;
    cursor: pointer;
    transition:
      border-color 180ms cubic-bezier(0.2, 0.8, 0.2, 1),
      background-color 180ms cubic-bezier(0.2, 0.8, 0.2, 1),
      transform 180ms cubic-bezier(0.2, 0.8, 0.2, 1);
  }
  .hd-script-choices__btn:hover:not([disabled]) {
    border-color: var(--hd-primary, #2563eb);
    background: rgb(var(--hd-primary-rgb, 37 99 235) / 0.06);
  }
  .hd-script-choices__btn:active:not([disabled]) {
    transform: scale(0.98);
  }
  .hd-script-choices__btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  @media (prefers-reduced-motion: reduce) {
    .hd-script-choices__btn {
      transition: none;
    }
  }
</style>
